module.exports = __webpack_public_path__ + "static/media/snoopywindy.98faf713.gif";